var _rect, _rect2, _rect3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResidualSplitProfileEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    fill: "none",
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 1,
    x: 8,
    y: 4,
    fill: "#8C8C8C",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 1,
    x: 8,
    y: 7,
    fill: "#8C8C8C",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 1,
    x: 8,
    y: 10,
    fill: "#8C8C8C",
    rx: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    fillRule: "evenodd",
    d: "M20 7h1.89C23.056 7 24 7.959 24 9.13v14.2c0 1.178-.95 2.132-2.11 2.132H2.11c-1.166 0-2.11-.96-2.11-2.131V9.13C0 7.954.95 7 2.11 7H4v1.422H2.406l9.637 9.645L21.6 8.422H20V7zM1.408 9.42v13.617l6.772-6.839L1.408 9.42zm7.77 7.775L2.401 24.04H21.6l-6.74-6.806-2.314 2.338c-.275.272-.718.278-.993 0l-2.374-2.376zm6.674-.964l6.74 6.806V9.425l-6.74 6.806z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8C8C8C",
    strokeWidth: 1.3,
    d: "M4.5 11.5V1h15v10.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidualSplitProfileEmail);
export default __webpack_public_path__ + "static/media/residualSplitProfileEmail.fe3c145bd1ea895f7ec8fd7307617583.svg";
export { ForwardRef as ReactComponent };